module.exports = __webpack_public_path__ + "static/img/rosepowder4.e2f89188.png";